import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=40f5d119&scoped=true&"
import script from "./alert.vue?vue&type=script&lang=ts&"
export * from "./alert.vue?vue&type=script&lang=ts&"
import style0 from "./alert.vue?vue&type=style&index=0&id=40f5d119&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f5d119",
  null
  
)

export default component.exports